// Home.jsx
import React from "react";
import { motion } from "framer-motion";
import wizMarket from "../../assets/image/home/wizMarketLogo.png"
import playStore from "../../assets/image/home/playstroeLogo.png"
import appStore from "../../assets/image/home/appStoreLogo.png"
import adsEx from "../../assets/image/home/iPhoneAds.svg"
import homeBody2 from "../../assets/image/home/homeBody2.svg"
import homeBody3 from "../../assets/image/home/homeBody3.png"
import homeBody4 from "../../assets/image/home/homeBody4.png"
import homeOverlay from "../../assets/image/home/homeOverlay.png"
import SandHome from "./components/SandHome.jsx";
import Price from "./components/Price.jsx"
import Concierge from "./components/Concierge.jsx";
// import PhoneShowcase from "./components/PhoneShowcase.jsx"


const container = {
    hidden: {},
    show: {
        transition: { delayChildren: 0.2, staggerChildren: 0.56 }
    }
};

const drop = {
    hidden: { opacity: 0, y: -48 },
    show: { opacity: 1, y: 0, transition: { duration: 1.4, ease: [0.22, 1, 0.36, 1] } }
};

const fade = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { duration: 1.4 } }
};

const group = {
    hidden: {},
    show: {
        transition: {
            when: "beforeChildren",
            delayChildren: 1.5,
            staggerChildren: 0    // 이미지와 버튼을 동시에 시작
        }
    }
};

 const Home = () => {
    return (

        <div className="min-h-screen bg-[#1B1A1B] text-white">
            <header className="top-0 z-50 bg-[#1B1A1B]">
                <div className="h-15 px-5 py-3 flex items-center justify-between text-white">
                    <a href="/" className="flex items-center gap-2 pl-6">
                        <img src={wizMarket} alt="wizMarket" className="h-8 w-auto" />
                        <p style={{ fontFamily: "SonsieOne" }}>wiz Market</p>
                    </a>
                    <div className="flex items-center gap-2">
                        <a href="/concierge/manage/login" className="px-4 py-2 inline-flex items-center rounded-md bg-[#2A2A2B] text-lg text-gray-200 hover:bg-[#323234]">
                            컨시어지 관리
                        </a>
                        <a href="/help" className="px-4 py-2 inline-flex items-center rounded-md bg-[#2A2A2B] text-lg text-gray-200 hover:bg-[#323234]">
                            고객센터
                        </a>
                        {/* <div className="px-4 py-2 inline-flex items-center rounded-md bg-[#7864F9] text-lg font-medium hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#7864F9]/60">
                            로그인/회원가입
                        </div> */}
                    </div>
                </div>
            </header>
            <motion.section
                variants={container}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.4 }}
                className="bg-[#1B1A1B] text-white py-20"
            >
                <div className="text-center px-6">
                    {/* 타이틀 */}
                    <motion.h2 variants={drop} className="text-3xl md:text-3xl font-bold leading-snug">
                        AI가 추천하는 광고를 체험하세요 <br />
                        <span className="block pt-2">
                            포스팅까지 이미지와 문구가 자동 생성됩니다.
                        </span>
                    </motion.h2>
                    <motion.p variants={drop} className="py-4 text-gray-400 text-m md:text-base">
                        AI가 매장 맞춤형 광고를 자동으로 제작합니다. 손쉽게 이미지를 완성하고 바로 포스팅까지 연결해 보세요.
                    </motion.p>

                    <motion.div variants={group} className="relative pd-12 flex justify-center transform-gpu overflow-hidden">
                        <motion.img variants={drop} src={adsEx} alt="광고 예시" />
                        <motion.div variants={fade} className="absolute top-6 z-10 flex justify-center gap-3">
                            <button className="px-4 py-2 rounded-xl bg-[#000000]/70 text-m flex items-center gap-2">
                                <img src={playStore} alt="플레이스토어" />안드로이드
                            </button>
                            <button className="px-4 py-2 rounded-xl bg-[#000000]/70 text-m flex items-center gap-2">
                                <img src={appStore} alt="앱스토어" />아이폰
                            </button>
                        </motion.div>
                    </motion.div>
                </div>
            </motion.section>
            <SandHome />
            <img src={homeBody2} alt="홈" />
            {/* <PhoneShowcase showHeader={true} headerEyebrow="Function"/> */}
            <img src={homeBody3} alt="홈" />

            {/* 가격 */}
            <Price />

            {/* 컨시어지 컴포넌트 */}
            <Concierge />



            <section className="relative min-h-[75vh] md:min-h-[85vh] isolate overflow-hidden flex items-center">
                <img
                    src={homeBody4}
                    alt="홈"
                    className="absolute inset-0 w-full h-full object-cover block"
                />
                <img
                    src={homeOverlay}
                    alt="필터"
                    className="absolute inset-0 w-full h-full object-cover pointer-events-none select-none block"
                />

                <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white">
                    <h1 className="font-extrabold leading-tight tracking-tight text-5xl">
                        ‘wizMarket’을 다운로드 하고,<br />
                        <span className="block pt-3">더 스마트한 마케팅을 시작하세요!</span>
                    </h1>

                    <p className="pt-6 text-gray-300 text-base md:text-lg">
                        지금 ‘wizMarket’을 다운로드하고, 내 매장에 맞는 AI 이미지를 생성해보세요. <br />
                        새로운 마케팅을 바로 시작할 수 있습니다!
                    </p>

                    {/* 스토어 버튼 */}
                    <div className="mt-10 flex justify-center gap-4">
                        <a
                            href="#android"
                            className="inline-flex items-center gap-2 rounded-full bg-white/70 text-gray-900
                            px-5 md:px-6 py-2.5 shadow-md hover:bg-white focus:outline-none
                            focus:ring-2 focus:ring-white/40"
                        >
                            <img src={playStore} alt="플레이스토어" className="w-5 h-5" />
                            <span className="text-sm md:text-base">안드로이드</span>
                        </a>
                        <a
                            href="#ios"
                            className="inline-flex items-center gap-2 rounded-full bg-white/70 text-gray-900
                            px-5 md:px-6 py-2.5 shadow-md hover:bg-white focus:outline-none
                            focus:ring-2 focus:ring-white/40"
                        >
                            <img src={appStore} alt="앱스토어" className="w-5 h-5" />
                            <span className="text-sm md:text-base">아이폰</span>
                        </a>
                    </div>
                </div>
            </section>

            <footer className="bg-[#1B1A1B] text-white">
                <div className="max-w-7xl mx-auto px-6 py-10">
                    <div className="flex items-start justify-between gap-8">
                        {/* 왼쪽 회사 정보 */}
                        <div className="space-y-2">
                            <div className="flex items-center gap-4 text-gray-300">
                                <p className="text-sm md:text-base">
                                    상호명: 제이예스주식회사 | 법인등록번호: 110111-4121143 | 사업자등록번호: 113-86-30615
                                </p>
                                <div className="flex items-center gap-3 text-gray-400">
                                    {/* <a href="#" aria-label="Instagram" className="hover:text-white">
                                        <AiOutlineInstagram className="w-5 h-5" />
                                    </a>
                                    <a href="#" aria-label="Naver" className="hover:text-white">
                                        <SiNaver className="w-5 h-5" />
                                    </a> */}
                                </div>
                            </div>

                            <p className="text-gray-400 text-sm md:text-base">
                                주소: 서울시 영등포구 영등포동8가 92 KnK 디지털타워 606호
                            </p>
                            <p className="text-gray-500 text-sm">
                                ©Copyright JYES All Rights Reserved
                            </p>
                        </div>

                        {/* 오른쪽 관련사이트 버튼 */}
                        <button
                            className="ml-auto inline-flex items-center gap-3 px-5 py-2 rounded-full bg-white text-gray-700 text-sm shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-white/30"
                        >
                            <span>관련사이트</span>
                            <span className="text-lg leading-none">+</span>
                        </button>
                    </div>
                </div>
            </footer>
        </div>

    );
};

export default Home;
